import React, { Component } from 'react'
import { connect } from 'react-redux'
import { selectStep, selectMode, selectFeature } from '../actions/commonActions'
import Indicator from '../components/common/Indicator'
import StepsList from '../components/common/StepsList'
import ResponseList from '../components/common/ResponseList'
import { FEATURES } from '../constants/common/Features'
import Response from '../components/common/Response'
import StepsMenu from '../components/common/StepsMenu'
import { toggleStepsList, toggleResponsesList, selectResponse } from '../actions/commonActions'
import responses from '../constants/vault/responses'
import Configuration from '../components/Vault/steps/Configuration'
import VaultAbout from '../components/Vault/steps/vaultabout'
import VaultTransactionType from '../components/Vault/steps/vaultTransactionType'
import VaultResAddCC from '../components/Vault/steps/vaultResAddCC'
import VaultEncryptedAdd from '../components/Vault/steps/vaultEncryptedAdd'
import VaultTempAdd from '../components/Vault/steps//vaultTempAdd'
import VaultUpdateCC from '../components/Vault/steps/vaultUpdateCC'
import VaultEncryptedUpdate from '../components/Vault/steps/vaultEncryptedUpdate'
import VaultLookUpFull from '../components/Vault/steps/vaultLookUpFull'
import VaultLookUpMask from '../components/Vault/steps/vaultLookUpMask'
import VaultGetExpiring from '../components/Vault/steps/vaultGetExpiring'
import VaultIsCorporateCard from '../components/Vault/steps/vaultIsCorporateCard'
import VaultResDelete from '../components/Vault/steps/vaultDelete'
import VaultAddToken from '../components/Vault/steps/vaultAddToken'
import VaultTokenizeCC from '../components/Vault/steps/vaultTokenizeCC'
import { _VAULT } from '../actions/types'
import Footer from '../components/common/Footer'

var isIE = /*@cc_on!@*/false || !!document.documentMode;
var isSafari = /constructor/i.test(window.HTMLElement) || (function (p) { return p.toString() === "[object SafariRemoteNotification]"; })(!window['safari'] || (typeof safari !== 'undefined' && window['safari'].pushNotification));

const scrollToRef = (ref) => {ref.current.scrollIntoView({behavior: "smooth"})}

export class VaultPage extends Component {
    state = {
        showError: false,
        ref1:React.createRef(),
        ref2:React.createRef(),
        ref3:React.createRef(),
        ref4:React.createRef(),
        ref5:React.createRef(),
        ref6:React.createRef(),
        ref7:React.createRef(),
        ref8:React.createRef(),
        ref9:React.createRef(),
        ref10:React.createRef(),
        ref11:React.createRef(),
        ref12:React.createRef(),
        ref13:React.createRef(),
        ref14:React.createRef(),
    }

    componentDidMount() {
        if(this.props.mode === "integration_guide")
            this.scrollIntoStep(this.props.selectedStep);

        document.title = 'Vault Administrative | Moneris Developers';
    }

    scrollIntoStep(stepId) {
        switch(stepId) {
            case 1:
                scrollToRef(this.state.ref1)
                break
            case 2:
                scrollToRef(this.state.ref2)
                break
            case 3:
                scrollToRef(this.state.ref3)
                break
            case 4:
                scrollToRef(this.state.ref4)
                break
            case 5:
                scrollToRef(this.state.ref5) 
                break 
            case 6:
                scrollToRef(this.state.ref6) 
                break
            case 7:
                scrollToRef(this.state.ref7) 
                break
            case 8:
                scrollToRef(this.state.ref8)
                break
            case 9:
                scrollToRef(this.state.ref9)
                break
            case 10:
                scrollToRef(this.state.ref10)
                break
            case 11:
                scrollToRef(this.state.ref11)
                break
            case 12:
                scrollToRef(this.state.ref12) 
                break 
            case 13:
                scrollToRef(this.state.ref13) 
                break
            case 14:
                scrollToRef(this.state.ref14) 
                break            
            
            default:
                scrollToRef(this.state.ref1)
                break
        }
    }

    renderNextSteps() {
        const { selectedResponse, resaddccSuccess, restempaddccSuccess, resupdateSuccess, resdeleteSuccess,
                reslookupfullSuccess, reslookupmaskSuccess, resgetexpiringSuccess, resiscorporatedcardSuccess,
                resaddtokenSuccess, restokenizeccSuccess } = this.props;

        const showNextStep = 
            (selectedResponse === 3 && resaddccSuccess) || 
            (selectedResponse === 5 && restempaddccSuccess) ||
            (selectedResponse === 6 && resupdateSuccess) ||
            (selectedResponse === 8 && resdeleteSuccess) ||
            (selectedResponse === 9 && reslookupfullSuccess) ||
            (selectedResponse === 10 && reslookupmaskSuccess) ||
            (selectedResponse === 11 && resgetexpiringSuccess) ||
            (selectedResponse === 12 && resiscorporatedcardSuccess) ||
            (selectedResponse === 13 && resaddtokenSuccess) ||
            (selectedResponse === 14 && restokenizeccSuccess) 

        if(showNextStep){
            return (
                <div className='sugestedNextSteps'>
                    <span>Suggested Next Steps:</span>
                    <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'left', alignItems: 'center', marginTop: '10px'}}>
                        <span className='suggestedBtn' onClick={() => this.props.selectStep({stepId: 6, featureId: _VAULT})}>Vault ResUpdate</span>
                        <span className='suggestedBtn' onClick={() => this.props.selectStep({stepId: 8, featureId: _VAULT})}>Vault ResDelete</span>
                        <span className='suggestedBtn' onClick={() => this.props.selectStep({stepId: 9, featureId: _VAULT})}>Vault Lookupfull</span>
                    </div>
                    <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'left', alignItems: 'center'}}>
                        <span className='suggestedBtn' onClick={() => this.props.selectStep({stepId: 10, featureId: _VAULT})}>Vault LookupMasked</span>
                        <span className='suggestedBtn' onClick={() => this.props.selectStep({stepId: 11, featureId: _VAULT})}>Vault Getexpiring</span>
                    </div>
                </div>
            );
        }

        if(this.state.showError){
            return(
                <div style={{ background: '#fff', width: '38vw', height: 'auto',padding: '1vw', paddingTop: '0px', marginLeft: '1.2vw'}}>
                    <h3>Please check with your             
                        <a href="https://developer.moneris.com/More/Testing/Response%20Codes" 
                            target="_blank" 
                            rel="noopener noreferrer"
                            style={{marginLeft:"0.5vw"}}>
                            ResponseCode
                        </a>
                    </h3>
                </div>
            )
        }
    }

    componentDidUpdate(prevProps) {
        //TODO fix and add updateResponse
        let ifShowAddCCError =  (this.props.selectedResponse === 3) && (this.props.ResAddCCResponse !== prevProps.ResAddCCResponse) && !this.props.resaddccSuccess
        let notShowAddCCError = (this.props.selectedResponse === 3) && (this.props.ResAddCCResponse !== prevProps.ResAddCCResponse) && this.props.resaddccSuccess
        let ifShowTempAddCCError = (this.props.selectedResponse === 5) &&(this.props.ResTempAddCCResponse !== prevProps.ResTempAddCCResponse) && !this.props.restempaddccSuccess
        let notShowTempAddCCError = (this.props.selectedResponse === 5) &&(this.props.ResTempAddCCResponse !== prevProps.ResTempAddCCResponse) && this.props.restempaddccSuccess
        let ifShowUpdateCCError = (this.props.selectedResponse === 6) &&(this.props.ResUpdateResponse !== prevProps.ResUpdateResponse) && !this.props.resupdateSuccess
        let notShowUpdateCCError = (this.props.selectedResponse === 6) &&(this.props.ResUpdateResponse !== prevProps.ResUpdateResponse) && this.props.resupdateSuccess
        let ifShowDeleteCCError = (this.props.selectedResponse === 8) &&(this.props.ResDeleteResponse !== prevProps.ResDeleteResponse) && !this.props.resdeleteSuccess
        let notShowDeleteCCError = (this.props.selectedResponse === 8) &&(this.props.ResDeleteResponse !== prevProps.ResDeleteResponse) && this.props.resdeleteSuccess
        let ifShowLookUpCCError = (this.props.selectedResponse === 9) &&(this.props.ResLookUpFullResponse !== prevProps.ResLookUpFullResponse) && !this.props.reslookupfullSuccess
        let notShowLookUpCCError = (this.props.selectedResponse === 9) &&(this.props.ResLookUpFullResponse !== prevProps.ResLookUpFullResponse) && this.props.reslookupfullSuccess
        let ifShowLookUpMCCError = (this.props.selectedResponse === 10) &&(this.props.ResLookUpMaskResponse !== prevProps.ResLookUpMaskResponse) && !this.props.reslookupmaskSuccess
        let notShowLookUpMCCError = (this.props.selectedResponse === 10) &&(this.props.ResLookUpMaskResponse !== prevProps.ResLookUpMaskResponse) && this.props.reslookupmaskSuccess
        let ifShowExpiringError = (this.props.selectedResponse === 11) &&(this.props.ResGetExpiringResponse !== prevProps.ResGetExpiringResponse) && !this.props.resgetexpiringSuccess
        let notShowExpiringError = (this.props.selectedResponse === 11) &&(this.props.ResGetExpiringResponse !== prevProps.ResGetExpiringResponse) && this.props.resgetexpiringSuccess
        let ifShowisCorError = (this.props.selectedResponse === 12) &&(this.props.ResIsCorporatedCardResponse !== prevProps.ResIsCorporatedCardResponse) && !this.props.resiscorporatedcardSuccess
        let notShowisCorError = (this.props.selectedResponse === 12) &&(this.props.ResIsCorporatedCardResponse !== prevProps.ResIsCorporatedCardResponse) && this.props.resiscorporatedcardSuccess
        let ifShowaddTokenError = (this.props.selectedResponse === 13) &&(this.props.ResAddTokenResponse !== prevProps.ResAddTokenResponse) && !this.props.resaddtokenSuccess
        let notShowaddTokenError = (this.props.selectedResponse === 13) &&(this.props.ResAddTokenResponse !== prevProps.ResAddTokenResponse) && this.props.resaddtokenSuccess
        let IfVaultShowError = ifShowAddCCError || ifShowTempAddCCError || ifShowUpdateCCError||ifShowDeleteCCError||ifShowLookUpCCError||ifShowLookUpMCCError||ifShowExpiringError||ifShowisCorError||ifShowaddTokenError
        let notVaultShowEror = notShowAddCCError || notShowTempAddCCError|| notShowUpdateCCError||notShowDeleteCCError||notShowLookUpCCError||  notShowLookUpMCCError||notShowExpiringError||notShowisCorError ||notShowaddTokenError 
        
        if(IfVaultShowError) {
            this.setState({ showError: true });
        }
        if(notVaultShowEror) {
            this.setState({ showError: false });
        }

        const { selectedStep, mode } = this.props;

        if(mode !== prevProps.mode && mode === 'integration_guide') {
            this.scrollIntoStep(selectedStep)
        }
    }

    isInViewport(elem) {
        if (!elem) return false;
        const offset = window.pageYOffset;
        const top = elem.getBoundingClientRect().top;
        return (top + offset) >= 0 && (top - offset) <= window.innerHeight;
    }

    justLeft(elem) {
        if (!elem) return false;
        const offset = window.pageYOffset;
        const top = elem.getBoundingClientRect().top;
        const diff = (top - offset) - window.innerHeight;
        return (top + offset) >= 0 && diff > 0 && diff < 100;
    }

    renderStepsContent() {
        if(this.props.mode === 'integration_guide') {
            return (
                <div className='pageContents'>
                    <div className='stepsContainer'>
                        <span ref={this.state.ref1}></span>
                        <VaultAbout/>
                        <span ref={this.state.ref2}></span>
                        <VaultTransactionType/>
                        <span ref={this.state.ref3}></span>
                        <VaultResAddCC/>
                        <span ref={this.state.ref4}></span>
                        <VaultEncryptedAdd/>
                        <span ref={this.state.ref5}></span>
                        <VaultTempAdd/>
                        <span ref={this.state.ref6}></span>
                        <VaultUpdateCC/>
                        <span ref={this.state.ref7}></span>
                        <VaultEncryptedUpdate/>
                        <span ref={this.state.ref8}></span>
                        <VaultResDelete/>
                        <span ref={this.state.ref9}></span>
                        <VaultLookUpFull/>
                        <span ref={this.state.ref10}></span>
                        <VaultLookUpMask/>
                        <span ref={this.state.ref11}></span>
                        <VaultGetExpiring/>
                        <span ref={this.state.ref12}></span>
                        <VaultIsCorporateCard/>
                        <span ref={this.state.ref13}></span>
                        <VaultAddToken/>
                        <span ref={this.state.ref14}></span>
                        <VaultTokenizeCC/>
                    </div>
                    <Footer />
                </div>
            )
        }
        else {
            switch(this.props.selectedStep) {
                case 1:
                    return <VaultAbout/>
                case 2:
                    return <VaultTransactionType/>
                case 3:
                    return <VaultResAddCC/>
                case 4:
                    return <VaultEncryptedAdd/>
                case 5:
                    return <VaultTempAdd/>        
                case 6:
                    return <VaultUpdateCC/>
                case 7:
                    return <VaultEncryptedUpdate/>
                case 8:
                    return <VaultResDelete/>
                case 9:
                    return <VaultLookUpFull/>
               case 10:
                    return <VaultLookUpMask/>
                case 11:
                    return <VaultGetExpiring/>
                case 12:
                    return <VaultIsCorporateCard/>
                case 13:
                    return <VaultAddToken/>
                case 14:
                    return <VaultTokenizeCC/>  
                default:
                    return null
            }
        }
    }

    handleScrolling() {
        const { ref1, ref2, ref3, ref4, ref5, 
                ref6,ref7,ref8,ref9,ref10,
                ref11,ref12,ref13,ref14
            } = this.state

        const { selectStep } = this.props

        if(this.isInViewport(ref1.current) || this.justLeft(ref2.current)) {
            selectStep({stepId: 1, featureId: _VAULT});
            return
        }
        if(this.isInViewport(ref2.current) || this.justLeft(ref3.current)) {
            selectStep({stepId: 2, featureId: _VAULT});
            return
        }
        if(this.isInViewport(ref3.current) || this.justLeft(ref4.current)) {
            selectStep({stepId: 3, featureId: _VAULT});
            return
        }
        if(this.isInViewport(ref4.current) || this.justLeft(ref5.current)) {
            selectStep({stepId: 4, featureId: _VAULT});
            return
        }
        if(this.isInViewport(ref5.current) || this.justLeft(ref6.current)) {
            selectStep({stepId: 5, featureId: _VAULT});
            return
        }
        if(this.isInViewport(ref6.current) || this.justLeft(ref7.current)) {
            selectStep({stepId: 6, featureId: _VAULT});
            return
        }
        if(this.isInViewport(ref7.current) || this.justLeft(ref8.current)) {
            selectStep({stepId: 7, featureId: _VAULT});
            return
        }
        if(this.isInViewport(ref8.current) || this.justLeft(ref9.current)) {
            selectStep({stepId: 8, featureId: _VAULT});
            return
        }
        if(this.isInViewport(ref9.current) || this.justLeft(ref10.current)) {
            selectStep({stepId: 9, featureId: _VAULT});
            return
        }
        if(this.isInViewport(ref10.current) || this.justLeft(ref11.current)) {
            selectStep({stepId: 10, featureId: _VAULT});
            return
        }
        if(this.isInViewport(ref11.current) || this.justLeft(ref12.current)) {
            selectStep({stepId: 11, featureId: _VAULT});
            return
        }
        if(this.isInViewport(ref12.current) || this.justLeft(ref13.current)) {
            selectStep({stepId: 12, featureId: _VAULT});
            return
        }
        if(this.isInViewport(ref13.current) || this.justLeft(ref14.current)) {
            selectStep({stepId: 13, featureId: _VAULT});
            return
        }
        if(this.isInViewport(ref14.current)) {
            selectStep({stepId: 14, featureId: _VAULT});
            return
        }
    }


    renderUpArrow() {
        if(this.props.mode === 'integration_guide') {
            if(isIE) {
                return (
                    <div style={{ marginLeft: '42vw', marginTop: '55vh'}} className='upArrow' onClick={() => this.scrollIntoStep(1)}>
                        <span style={{ marginTop: '1vh' }}>&#8679;</span>
                    </div>
                );
            }
            else if(isSafari) {
                return (
                    <div style={{ marginLeft: '45vw', marginTop: '30vh', paddingBottom: '1vh'}} className='upArrow' onClick={() => this.scrollIntoStep(1)}>
                        <span style={{ marginTop: '1vh' }}>&#8679;</span>
                    </div>
                );
            }
            else {
                if(navigator.platform === "Win32") {
                    return (
                        <div className='upArrow' onClick={() => this.scrollIntoStep(1)}>
                            <span>&#129093;</span>
                        </div>
                    );
                }
                else {
                    return (
                        <div className='upArrow' onClick={() => this.scrollIntoStep(1)}>
                            <span>&#8679;</span>
                        </div>
                    );
                }
            }
        }
    }    

    
//TODO fix this
    renderResponseContent() {
        switch(this.props.selectedResponse) {
            case 3:
                return <Response title="Actual RssAddCC Output" output={this.props.ResAddCCResponse} loading={this.props.loading}/>
            case 5:
                return <Response title="Actual ResTempAdd Output" output={this.props.ResTempAddCCResponse} loading={this.props.loading}/>
            case 6:
                return <Response title="Actual ResUpdateCCC Output" output={this.props.ResUpdateResponse} loading={this.props.loading}/>
            case 8:
                return <Response title="Actual ResDelete Output" output={this.props.ResDeleteResponse} loading={this.props.loading}/>
            case 9:
                return <Response title="Actual ResLookupFull Output" output={this.props.ResLookUpFullResponse} loading={this.props.loading}/>
            case 10:
                return <Response title="Actual ResLookupMasked Output" output={this.props.ResLookUpMaskResponse} loading={this.props.loading}/>
            case 11:
                return <Response title="Actual ResGetExpiring Output" output={this.props.ResGetExpiringResponse} loading={this.props.loading}/>
            case 12:
                return <Response title="Actual ResIscorporateCard Output" output={this.props.ResIsCorporatedCardResponse} loading={this.props.loading}/>
            case 13:
                return <Response title="Actual ResAddToken Output" output={this.props.ResAddTokenResponse} loading={this.props.loading}/>
            case 14:
                return <Response title="Actual ResTokenizeCC Output" output={this.props.ResTokenizeeCCResponse} loading={this.props.loading}/>
           
            default:
                return null
        }
    }

    renderRightSide() {
        const { selectResponse, toggleResponsesList, isResponsesListOpen, selectedResponse, mode } = this.props;
        if(mode === 'interactive_tool') {
            return (
                    <div className="rightContainer">
                        <ResponseList
                            isOpen={isResponsesListOpen}
                            selection={selectedResponse}
                            responses={responses.filter((response) => this.props.history.includes(response.id))}
                            toggleResponseList={toggleResponsesList}
                            selectResponse={selectResponse}
                            featureId={_VAULT}
                        />
                        <div className="rightContents">
                            {this.renderResponseContent()}
                            {this.renderNextSteps()}
                        </div>
                    </div>
            );
        }
    }

    renderLeftSide() {
        const { selectedStep, selectStep, toggleStepsList, isStepsListOpen, mode } = this.props;
        const steps = FEATURES.vault.steps;

        if(mode === 'interactive_tool') {
            return (
                <div className='leftContainer'>
                    <StepsList 
                        isOpen={isStepsListOpen}
                        selection={selectedStep} 
                        toggleStepsList={toggleStepsList} 
                        steps={steps}
                        selectStep={selectStep}
                        featureId={_VAULT}
                    />
                    {this.renderStepsContent()}
                </div>
            );
        }
        else {
            return (
                <div className='documentContainer' onWheel={() => this.handleScrolling()}>
                    <StepsMenu 
                        selectStep={selectStep}
                        selection={selectedStep}
                        steps={steps}
                        featureId={_VAULT}
                        scrollIntoStep={(stepId) => this.scrollIntoStep(stepId)}
                    /> 
                    {this.renderStepsContent()}
                </div>
            );
        }
    }

    render() {
        const { selectedStep, selectStep } = this.props;

        return (
            <div className="desktop">
                <Indicator 
                    title="Vault Administrative Transactions"
                    steps={FEATURES.vault.steps}
                    renderConfig={() => <Configuration />}
                    selection={selectedStep}
                    selectStep={selectStep} 
                    isInteractive={() => ![1, 2, 4, 7, 15, 21].includes(selectedStep)}
                    history={this.props.history}
                />
                
                <div className="mainContainer">
                    {this.renderLeftSide()}
                    {this.renderRightSide()}
                    {this.renderUpArrow()}
                </div>
            </div>
        )
    }
}

const mapStateToProps = state => {
    const selectedStep = state.vault.stepsList.selection;
    const isStepsListOpen = state.vault.stepsList.isOpen;
    const selectedResponse = state.vault.responseList.selection;
    const isResponsesListOpen = state.vault.responseList.isOpen;
    const { prevSuccStep, loading,history } = state.vault.main;
    const { mode } = state.common.sideNav;
    const {  ResAddCCResponse,
            ResTempAddCCResponse,
            ResUpdateResponse,
            ResDeleteResponse,
            ResLookUpFullResponse,
            ResLookUpMaskResponse,
            ResGetExpiringResponse,
            ResIsCorporatedCardResponse,
            ResAddTokenResponse,
            ResTokenizeeCCResponse,
            ResPurchaseResponse,
            ResPreauthResponse,
            ResIndRefundResponse,
            ResForcePostResponse,
            purchaseSuccess,
            resaddccSuccess,
            restempaddccSuccess,
            resupdateSuccess,
            resdeleteSuccess,
            reslookupfullSuccess,
            reslookupmaskSuccess,
            resgetexpiringSuccess,
            resiscorporatedcardSuccess,
            resaddtokenSuccess,
            restokenizeccSuccess,
            respurchaseSuccess,
            respreauthSuccess,
            resindrefundccSuccss,
            resforcepostccSuccss,
            rescardverificationSuccess,
            resCardVerificationResponse
        } = state.vault.main;
    return { history,selectedStep, isStepsListOpen, selectedResponse, isResponsesListOpen, prevSuccStep, mode, loading,
            ResAddCCResponse,
            ResTempAddCCResponse,
            ResUpdateResponse,
            ResDeleteResponse,
            ResLookUpFullResponse,
            ResLookUpMaskResponse,
            ResGetExpiringResponse,
            ResIsCorporatedCardResponse,
            ResAddTokenResponse,
            ResTokenizeeCCResponse,
            ResPurchaseResponse,
            ResPreauthResponse,
            ResIndRefundResponse,
            ResForcePostResponse,
            purchaseSuccess,
            resaddccSuccess,
            restempaddccSuccess,
            resupdateSuccess,
            resdeleteSuccess,
            reslookupfullSuccess,
            reslookupmaskSuccess,
            resgetexpiringSuccess,
            resiscorporatedcardSuccess,
            resaddtokenSuccess,
            restokenizeccSuccess,
            respurchaseSuccess,
            respreauthSuccess,
            resindrefundccSuccss,
            resforcepostccSuccss,
            rescardverificationSuccess,
            resCardVerificationResponse };
}

export default connect(mapStateToProps, {selectStep, selectMode, toggleStepsList, toggleResponsesList, selectResponse, selectFeature})(VaultPage);
